import { render, staticRenderFns } from "./saima_a.vue?vue&type=template&id=9673881e&scoped=true"
import script from "./saima_a.vue?vue&type=script&lang=js"
export * from "./saima_a.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673881e",
  null
  
)

export default component.exports